import { styled, Typography, TypographyProps } from "@mui/material";
export const Labeltext = styled(Typography)<TypographyProps>(({ theme }) => ({
  fontFamily: "Mont",
  fontSize: 14,
  fontWeight: 400,
  textOverflow: "ellipsis",
}));
